<template>
  <div class="more-away">
    <div class="ha-des">
      <p class="black">问：如何注销可瀚学堂账号？</p>
      <p>答：<br>1、账号一经注销则无法登录，关联的班级以及激活的课程等数据都将被清除，账号注销不可逆；<br><br>2、确定以上条件后，请致电客服：17796327580，告知注销原因后，即可注销可瀚学堂账号。</p>
    </div>
    
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .more-away {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(15) 0;
      font-size: p2r(15);
      color: $a77;
      p {
        margin: p2r(10) 0;
      }
    }
  }
</style>
<script>
  export default{
    data(){
      return {}
    },
    created(){
      document.title = '其他问题? 可瀚学堂-深圳市格熙信息科技有限公司'
      this.$sendAnalytics('点击如何注销学堂账号')
    },
    methods: {
      skip(name) {
        this.$router.push({
          name: name
        });
      }
    },
    components: {}
  }
</script>
